import WhitelabelingBanner from './WhitelabelingBanner.component';

export default WhitelabelingBanner;